import React from 'react';
import Grid from '@material-ui/core/Grid';
import CountrySelector from '../CountryCodeSelector';
import { StyledInput } from './style';
import FieldWrapper from './FieldWrapper';
import Text from '../Text';
import { onKeyPress } from '../../../utils';
import {
  DEFAULT_COUNTRY_CODE,
  SINGAPORE_PHONE_LENGTH,
} from '../../../utils/constants';
import { validateSingaporePhoneFormat } from '../../../utils/countryCodeUtils';
import errorMsg from '../../../translations/en/common.json';

export const PhoneField = ({
  label,
  name,
  value,
  disabled,
  onChange,
  error,
  autoFocus,
  onCodeChange,
  required,
  labelStyle = { marginTop: '0px', paddingBottom: '0px' },
  defaultCountryCode,
  countryCodeDisabled = false,
  onBlur,
  placeholder,
  labelTextColor,
  wrapperStyle,
  inputStyle = {},
  alternateView = false,
  hideIndicatorSeparator = false,
}) => {
  const isSingapore =
    defaultCountryCode?.value?.substring(0, 3) === DEFAULT_COUNTRY_CODE;
  const isInvalidLength =
    isSingapore && value?.length > 0 && value?.length < SINGAPORE_PHONE_LENGTH;

  const handleCountryCodeChange = selectedOption => {
    // Update the country code in the parent state
    onCodeChange(selectedOption);

    const newIsSingapore =
      selectedOption?.value?.substring(0, 3) === DEFAULT_COUNTRY_CODE;

    // Prepare the phone value based on the new country selection
    let newValue = value;

    if (newIsSingapore && value?.length > SINGAPORE_PHONE_LENGTH) {
      // Truncate to 8 digits if switching TO Singapore
      newValue = value.substring(0, SINGAPORE_PHONE_LENGTH);
    }

    // Trigger the parent's onChange.
    onChange({
      target: {
        name,
        value: newValue,
      },
    });
  };
  return (
    <FieldWrapper
      required={required}
      label={label}
      name={name}
      styles={labelStyle}
      disabled={disabled}
      labelTextColor={labelTextColor}
      wrapperStyle={wrapperStyle}
    >
      <Grid
        container
        spacing={alternateView ? 2 : 0}
        style={{ justifyContent: 'space-between' }}
      >
        <Grid item xs={5} md={alternateView ? 3 : 5}>
          <CountrySelector
            hideIndicatorSeparator={hideIndicatorSeparator}
            defaultValue={defaultCountryCode}
            isDisabled={countryCodeDisabled || disabled}
            handleSelectChange={handleCountryCodeChange}
            onBlur={onBlur}
          />
        </Grid>
        <Grid item xs={6} md={alternateView ? 9 : 6}>
          <StyledInput
            id={name}
            name={name}
            value={value}
            autoFocus={!disabled && Boolean(autoFocus)}
            disabled={disabled}
            onChange={e => {
              const onlyNums = validateSingaporePhoneFormat(
                isSingapore,
                e.target.value
              );
              onChange({
                ...e,
                target: {
                  ...e.target,
                  name,
                  value: onlyNums,
                },
              });
            }}
            onBlur={onBlur}
            placeholder={placeholder}
            onKeyPress={e => onKeyPress(e, 'phone')}
            // Trigger numeric keyboard on mobile devices
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              maxLength: isSingapore ? SINGAPORE_PHONE_LENGTH : undefined,
            }}
            inputStyle={{ padding: '9px 0px', ...inputStyle }}
          />
          <Text label color="error">
            {isInvalidLength ? errorMsg.common.singaporePhoneError : error}
          </Text>
        </Grid>
      </Grid>
    </FieldWrapper>
  );
};

export default PhoneField;
